
function highlightArtist(evt) {

    let mainNode = this.parentElement;
    mainNode.classList.toggle('--hover');
    document.body.classList.toggle('--fade');


    if (evt.type == 'mouseenter') {
        updateBodyColor(mainNode.getAttribute('data-bgcolor'));
    }

    if (evt.type == 'mouseleave') {
        document.body.removeAttribute('style');
    }
}




document.addEventListener('DOMContentLoaded', function() {

    if (document.body.classList.contains('artists')) {

        // GESTIONE EDIZIONI DEGLI ALTRI ANNI
        let editions = this.documentElement.querySelectorAll('.edition .year');

        if (editions.length > 1) {

            editions.forEach(function(el, idx) {
                
                el.addEventListener('click', function(){

                    document.querySelector('.edition.current').classList.remove('current');
                    let edition = this.parentNode;
                    

                    edition.classList.add('current');
                    edition.classList.remove('next', 'prev');
                    
                    let found = false;
                    document.querySelectorAll('.edition').forEach(function (item, i) {
                        item.classList.remove('next', 'prev');
                        if (item.classList.contains('current'))
                            found = true;
                        else
                            item.classList.add(found ? 'next' : 'prev');
                    });
                    
                });
            });
        }
        
        // Switch to header-small
        let scrollThreshold = 80; // scroll in px per lo switch alla versione "small"
        let scrollTolerance = 40; // tolleranza in px sullo scroll disponibile della pagina per evitare sfarfallamenti
        
        gsap.registerPlugin(ScrollTrigger);
        ScrollTrigger.create({
            trigger: "main",
            start: scrollThreshold,
            //toggleClass: {className: '--header-small', targets: 'body'}
            onEnter: function () {
                let pageScroll = document.documentElement.offsetHeight - document.documentElement.clientHeight;
                if (pageScroll >= scrollThreshold + scrollTolerance) {
                    document.body.classList.add('--header-small');
                }
            },
            onLeaveBack: function () {
                document.body.classList.remove('--header-small');
            },
            onUpdate: function () {
                let pageScroll = document.documentElement.offsetHeight - document.documentElement.clientHeight;
                if ((pageScroll >= scrollThreshold + scrollTolerance)
                    && (!document.body.classList.contains('--header-small'))) {
                    document.body.classList.add('--header-small');
                }
            },
        });


        // Home effects - only for desktop
        if ((desktopScreen.matches) || (tabletLandscape.matches)) {
            
            if (this.documentElement.querySelectorAll('.authors-list').length > 0) {
                let elements = this.documentElement.querySelectorAll('.authors-list li a');
                elements.forEach(function(el, idx) {
                    
                    // lazy load
                    let img = el.querySelector('img');
                    img.setAttribute('src', img.getAttribute('data-src'));

                    // hover handlers
                    el.querySelector('span').addEventListener('mouseenter', highlightArtist);
                    el.querySelector('span').addEventListener('mouseleave', highlightArtist);
                });
            }

            // Preview binding with mouse position
            window.onmousemove = e => {
                const mouseX = e.clientX,
                    mouseY = e.clientY;
                
                let preview = document.querySelectorAll('.current .authors-list li a img');
                
                preview.forEach((pic) => {
                    let minX = pic.width / 2;
                    let maxX = document.documentElement.clientWidth - (pic.width / 2);

                    let mouseXfixed = (mouseX < minX) ? minX : ( (mouseX > maxX) ? maxX : mouseX);

                    pic.animate({
                        top: mouseY - (pic.height / 2) + 'px',
                        left: mouseXfixed - (pic.width / 2) + 'px'
                    }, {
                        duration: 200,
                        fill: "forwards",
                        easing: "ease-in-out"
                    })
                });
            }
        }

    }
    
});



